import {Box} from '@primer/react'
import type {BetterSystemStyleObject} from '@primer/react/lib-esm/sx'
import type {PropsWithChildren} from 'react'
import {testIdProps} from '@github-ui/test-id-props'

const defaultStyles: BetterSystemStyleObject = {
  display: 'flex',
  flexDirection: 'row',
  pr: 3,
  gap: 2,
  gridArea: 'metadata',
  flexGrow: 2,
}

export function MetadataContainer({children}: PropsWithChildren) {
  return (
    <Box sx={defaultStyles} {...testIdProps('listview-item-metadata')}>
      {children}
    </Box>
  )
}

try{ MetadataContainer.displayName ||= 'MetadataContainer' } catch {}